module.exports = __webpack_public_path__ + "img/logo.176e41ec.png";